export const TOURNAMENTS = 'tournaments';
export const TOURNAMENT = 'tournament';
export const TRACK = 'track';
export const SPLASH = 'splash';
export const EVENT = 'event';
export const DRAW = 'draw';
export const STRUCTURE = 'structure';

export const views = [TOURNAMENTS, TOURNAMENT, TRACK, SPLASH];
